<div #viatorGroupContainer class="viator-group__swiper-box" appSwiper [swiperOptions]="swiperOptions">
    <div class="swiper-wrapper viator-group__list">
        @if (!isFetching) {
            @for (item of events; track index; let index = $index) {
                <div class="swiper-slide viator-group__list--item">
                    <a class="item-href" [attr.href]="item.url" target="_blank" (click)="bookNow.emit(item)">
                        <div class="item-image" [style.background-image]="'url(' + item?.imageUrl + ')'">
                            @if (item.price) {
                                <div class="item-price">
                                    Starting from {{ item.currency + '  ' + item.price }}
                                </div>
                            }
                        </div>
                        <p class="item-text">{{ item.name }}</p>

                        <div class="item-actions">
                            <div class="item-actions__row">
                                <button class="btn-hurt"
                                        [class.active]="favoritesProviderService.isFavorite('viator', item.id)"
                                        (click)="toggleHurt($event, item)">
                                    <mat-icon [svgIcon]="eSvgIcons.HURT"></mat-icon>
                                </button>
                                <button class="btn-default btn-buy">Book</button>
                            </div>
                        </div>
                    </a>
                </div>
            }
        } @else {
            @for (item of fetchingItems; track $index) {
                <div class="swiper-slide fetching-slide" #slideRef>
                    <ngx-skeleton-loader
                            [theme]="{height: slideRef.clientHeight + 'px', margin: 0}"></ngx-skeleton-loader>
                </div>
            }
        }
    </div>

    <div class="swiper-button-prev with-background"></div>
    <div class="swiper-button-next with-background"></div>
</div>
